import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {BlocchiListComponent, CercaFilter} from "./blocchi-list/blocchi-list.component";
import {NgMultiSelectDropDownModule} from "../../LibrerieCustom/MultiselectDropdown";
import {FormsModule} from "@angular/forms";
import {FeatherModule} from "angular-feather";
import { BlocchiComponent } from './blocchi/blocchi.component';
import {RouterModule} from "@angular/router";
import { ContenutiComponent } from './contenuti/contenuti.component';
import { BlocchiEditComponent } from './blocchi-edit/blocchi-edit.component';
import {NgbTooltipModule} from "@ng-bootstrap/ng-bootstrap";
import {HttpClient} from "@angular/common/http";


export const routes = [
{
    path: 'blocchi/list',
    data: {
      title: 'menu.Blocchi',
      urls: [{ title: 'menu.Blocchi' }],
    },
    component: BlocchiComponent,
  },
  {
    path: 'blocchi/edit/:id',
    data: {
      title: 'blocchi.blocco',
      urls: [{ title: 'menu.Blocchi', url: "/blocchi/blocchi/list" }, {title: 'blocchi.blocco'}],
    },
    component: BlocchiEditComponent,
  },
  {
    path: 'blocchi/edit',
    data: {
      title: 'blocchi.blocco',
      urls: [{ title: 'menu.Blocchi', url: "/blocchi/blocchi/list" }, {title: 'blocchi.blocco'}],
    },
    component: BlocchiEditComponent,
  },
]


@NgModule({
  declarations: [BlocchiListComponent, CercaFilter, BlocchiComponent, ContenutiComponent, BlocchiEditComponent],
  exports: [
    BlocchiListComponent
  ],
  imports: [
    CommonModule,
    NgMultiSelectDropDownModule,
    FormsModule,
    FeatherModule,
    RouterModule.forChild(routes),
    NgbTooltipModule,
  ],
  providers: [HttpClient]
})
export class BlocchiModule { }
